<template>
  <div class="text-xs-center">
    <v-dialog :value="value" @input="$emit('input')" width="100%">
      <v-card v-if="filters && showFiltros">
        <v-toolbar dense color="grey lighten-2">
          <v-toolbar-title class="title">Filtros</v-toolbar-title>
          <v-divider
            class="mx-2"
            inset
            vertical
          ></v-divider>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <v-btn icon @click="showFiltros = false" slot="activator">
              <v-icon>close</v-icon>
            </v-btn>
            <span>Cancelar</span>
          </v-tooltip>
          
          <v-tooltip bottom>
            <v-btn icon @click="aplicaFiltros" slot="activator">
              <v-icon>done</v-icon>
            </v-btn>
            <span>Aplicar</span>
          </v-tooltip>
        </v-toolbar>
        <v-container fluid grid-list-xl>
          <v-layout row wrap>
            <v-flex xs12 md3 :py-0="$vuetify.breakpoint.smAndDown">
              <v-select
                v-model="filtros.idTipoAtividade"
                :items="tiposAtividadeAtivo"
                item-text="Descricao"
                item-value="IdTipoAtividade"
                prepend-icon="description"
                label="Tipo Atividade"
                no-data-text="Nenhum registro encontrado"
              ></v-select>
            </v-flex>
            <v-flex xs12 md3 :py-0="$vuetify.breakpoint.smAndDown">
              <v-select
                v-model="filtros.status"
                :items="statusAtividade"
                label="Status"
                prepend-icon="description"
                no-data-text="Nenhum registro encontrado"
              ></v-select>
            </v-flex>
            <v-flex xs12 md3 :py-0="$vuetify.breakpoint.smAndDown">
              <v-menu v-model="periodoDatepickerInicial" :close-on-content-click="false" full-width>
                <v-text-field readonly slot="activator"
                  :value="moment(filtros.dataInicial).format('DD/MM/YYYY')" label="Data Inicial" prepend-icon="event">
                </v-text-field>
                <v-date-picker @change="periodoDatepickerInicial = false" locale="pt" v-model="filtros.dataInicial"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs12 md3 :py-0="$vuetify.breakpoint.smAndDown">
              <v-menu v-model="periodoDatepickerFinal" :close-on-content-click="false" full-width>
                <v-text-field readonly slot="activator"
                  :value="moment(filtros.dataFinal).format('DD/MM/YYYY')" label="Data Final" prepend-icon="event">
                </v-text-field>
                <v-date-picker @change="periodoDatepickerFinal = false" locale="pt" v-model="filtros.dataFinal"></v-date-picker>
              </v-menu>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
      <v-card>
        <v-card-title class="title grey lighten-2" :class="{ 'py-0': $vuetify.breakpoint.smAndUp }" primary-title>
          Vincular Atividades
          <v-spacer></v-spacer>
          <v-text-field
            class="mr-2"
            v-model="searchTerm"
            append-icon="search"
            clearable
          ></v-text-field>
          <v-tooltip bottom v-if="filters">
            <v-btn
              icon
              slot="activator"
              :loading="loading"
              @click="showFiltros = true">
              <v-icon>filter_list</v-icon>
            </v-btn>
            <span>Filtros</span>
          </v-tooltip>
          <v-tooltip bottom>
            <v-btn
              icon
              slot="activator"
              :loading="loading"
              @click="aplicaFiltros">
              <v-icon>refresh</v-icon>
            </v-btn>
            <span>Atualizar</span>
          </v-tooltip>
          <v-tooltip bottom>
            <v-btn icon @click="$emit('input')" slot="activator">
              <v-icon>close</v-icon>
            </v-btn>
            <span>Cancelar</span>
          </v-tooltip>
          <v-tooltip bottom>
            <v-btn
              slot="activator"
              color="primary"
              icon
              class="elevation-5"
              :loading="loading"
              @click="$emit('vinculaAtividade')">
              <v-icon>done</v-icon>
            </v-btn>
            <span>Vincular</span>
          </v-tooltip>
        </v-card-title>
        <v-card-text class="pa-0">
          <Grid
            :items="atividades"
            :searchTerm="searchTerm"
            :loading="loading"
            slot="pendentes"
            :forcePagConfigDefault="true"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Grid from "@/components/shared/Grid";

export default {
  name: 'ModalListAtividade',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    items: {
      type: Array,
      default: () => [] 
    },
    filters: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    searchTerm: '',
    showFiltros: true,
    periodoDatepickerInicial: false,
    periodoDatepickerFinal: false,
    statusAtividade: [
      { text: 'PENDENTE', value: 'P' },
      { text: 'FINALIZADA', value: 'F' }
    ],
    filtros: {
      idTipoAtividade: 1,
      status: 'P',
      dataInicial: new Date().toISOString().substr(0, 10),
      dataFinal: new Date().toISOString().substr(0, 10)
    }
  }),
  components: {
    Grid,
  },
  watch: {
    value(v) {
      if (v && !this.tiposAtividadeAtivo.length) {
        this.fetchTiposAtividade();
      }
    }
  },
  computed: {
    ...mapGetters(["tiposAtividadeAtivo"]),
    atividades() {
      return this.filters ? this.items : this.$store.getters.atividades;
    }
  },
  methods: {
    ...mapActions(['fetchTiposAtividade']),
    saveFiltersConfig() {
      if (this.filters)
        localStorage.setItem('modalListFilters', JSON.stringify(this.filtros));
    },
    loadFiltersConfig() {
      if (this.filters) {
        const savedFiltros = localStorage.getItem('modalListFilters');
  
        if (savedFiltros) {
          this.filtros = JSON.parse(savedFiltros);
        }
      }
    },
    aplicaFiltros() {
      this.showFiltros = false;
      this.$emit('atualizaListaAtividadesVincular', this.filtros);
      this.saveFiltersConfig();
    }
  },
  created() {
    this.loadFiltersConfig();
  }
};
</script>

<style>
</style>
